import * as React from "react";
import { Path, G, Mask, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const UKIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 12" fill="none" title="UK" {...props}>
    <G clipPath="url(#a)">
      <Path fill="#fff" d="M0 0h16v12H0z" />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#fff"
          d="m-1.781 11.143 3.52 1.489L16.08 1.619l1.857-2.213-3.765-.497-5.85 4.745-4.707 3.198-5.396 4.29Z"
        />
        <Path
          fill="#F50100"
          d="m-1.3 12.186 1.794.864L17.27-.8h-2.518L-1.3 12.187Z"
        />
        <Path
          fill="#fff"
          d="m17.782 11.143-3.521 1.489L-.08 1.619-1.938-.594l3.765-.497 5.85 4.745 4.707 3.198 5.397 4.29Z"
        />
        <Path
          fill="#F50100"
          d="m17.662 11.891-1.794.865-7.144-5.93-2.117-.663-8.723-6.75H.403l8.717 6.59 2.316.795 6.226 5.093Z"
        />
        <Mask id="c" fill="#fff">
          <Path
            fillRule="evenodd"
            d="M9.889-1H6.11v5H-.986v4H6.11v5H9.89V8h7.125V4H9.889v-5Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M9.889-1H6.11v5H-.986v4H6.11v5H9.89V8h7.125V4H9.889v-5Z"
          clipRule="evenodd"
        />
        <Path
          fill="#fff"
          d="M6.111-1v-1h-1v1h1ZM9.89-1h1v-1h-1v1ZM6.11 4v1h1V4h-1ZM-.986 4V3h-1v1h1Zm0 4h-1v1h1V8ZM6.11 8h1V7h-1v1Zm0 5h-1v1h1v-1Zm3.778 0v1h1v-1h-1Zm0-5V7h-1v1h1Zm7.125 0v1h1V8h-1Zm0-4h1V3h-1v1ZM9.889 4h-1v1h1V4ZM6.11 0H9.89v-2H6.11v2Zm1 4v-5h-2v5h2ZM-.986 5H6.11V3H-.986v2Zm1 3V4h-2v4h2ZM6.11 7H-.986v2H6.11V7Zm1 6V8h-2v5h2Zm2.778-1H6.11v2H9.89v-2Zm-1-4v5h2V8h-2Zm8.125-1H9.889v2h7.125V7Zm-1-3v4h2V4h-2ZM9.889 5h7.125V3H9.889v2Zm-1-6v5h2v-5h-2Z"
          mask="url(#c)"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v12H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
